import { pick } from 'lodash'
import PromtForm from './_form'
import template from './edit.pug'
import API from 'js/services/api'

export default Vue.extend({
  template: template(),
  components: {
    PromtForm
  },
  data() {
    return {
      ready: false,
      data: {},
      errors: {}
    }
  },
  watch: {
    '$route.params.promtId': {
      immediate: true,
      handler() {
        this.$setPageTitle(this.$t('promtsAi.edit.title'))
        this.loadData()
      }
    }
  },
  methods: {
    loadData() {
      this.ready = false

      API.promtsAi.show(this.$route.params.id, this.$route.params.promtId)
        .then(response => {
          console.log('[EDIT] response from API.show:', response)

          this.data = pick(response, ['id', 'name', 'description', 'promt'])

          this.$setBreadcrumbs([
            {
              label: this.$t('promtsAi.breadcrumbs.promtsAi.index'),
              route: { name: 'promts-ai-index', params: { id: this.$route.params.id } }
            },
            {
              label: this.$t('promtsAi.breadcrumbs.promtsAi.edit', { name: this.data.name }),
              route: {}
            }
          ])
          this.ready = true
        })
        .catch(err => {
          console.error('[EDIT] Error en API.promtsAi.show:', err)
          this.$notifications.error(this.$t('promtsAi.edit.loadError'))
          this.$router.push({ name: 'promts-ai-index', params: { id: this.$route.params.id } })
        })
    },

    updatePromt(data) {

      API.promtsAi.update(this.$route.params.id, this.$route.params.promtId, data)
        .then(() => {
          console.log('[EDIT] Promt actualizado correctamente')
          this.$notifications.success(this.$t('promtsAi.edit.succesfullyUpdated'))
          this.$router.push({name: 'accounts-laia-promts', params: {id: this.$route.params.id}})
        })
        .catch(errors => {
          console.error('[EDIT] Errores en updatePromt:', errors)
          this.errors = errors
        })
    }
  }
})
